import React, { useState } from 'react';

import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CreateServicenow } from 'containers/Setup/Integrations/Components/IntegrationsWizard/ServiceNow/Components/CreateServicenow';
import { EditServicenow } from 'containers/Setup/Integrations/Components/IntegrationsWizard/ServiceNow/Components/EditServicenow';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions } from '../../../../slice';

export const ServicenowWizard = () => {
  const { activeClient } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const { onCancel } = useIntegrations();
  const params = useParams<{
    provider: string;
    id: string;
  }>();

  const [validate, setValidate] = useState(false);

  const onUpdate = data => {
    const { name, assignee } = data;
    const payload: ClientsApiEditClientRequest = {
      uuid: activeClient.data?.uuid,
      editClientConfig: {
        name,
        status: true,
        service_now: {
          assignee: assignee?.value?.username,
        },
      },
    };
    dispatch(
      actions.updateClientById({ q: payload, onSuccess: () => onCancel() }),
    );
  };

  return !params?.id ? (
    <CreateServicenow
      onSubmit={onUpdate}
      validate={validate}
      setValidate={setValidate}
    />
  ) : (
    <EditServicenow onSubmit={onUpdate} />
  );
};
